// React-Query hook для POST /consents (Sprint 2 A-6).
// Source of truth: docs/specs/sprint-3/stage-1-contracts.md §8.1.
//
// Submit-body: { consent_version, flags: {3 boolean} } — version обязателен,
// backend version-match'ит с config('healthlab.current_consent_version') (см. stage-4 §5.8 / Q6).

import { useMutation, useQueryClient, type UseMutationResult } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { api } from '@/api/client';
import { queryKeys } from '@/api/queryKeys';
import type {
  ApiError,
  PostConsentRequest,
  PostConsentResponse,
} from '@/api/types';

export function usePostConsent(): UseMutationResult<PostConsentResponse, AxiosError<ApiError>, PostConsentRequest> {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body) => {
      const { data } = await api.post<PostConsentResponse>('/consents', body);
      return data;
    },
    onSuccess: async () => {
      // Auto-invalidate (см. stage-4 §2.2): consent меняет user.consent_version,
      // что переключает onboarding state. Токен уже актуален → race не грозит.
      // Ждём profileMe refresh: иначе S-9 RequireConsent может увидеть старый
      // user.consent_version из cache и вернуть пользователя на /consent.
      await qc.invalidateQueries({ queryKey: queryKeys.profileMe });
    },
  });
}
